/** @format */

import React from 'react'
import styled from 'styled-components'
import { Drawer } from '@king-design/react'
import FormDesignable from 'src/components/FormDesignable'
import { ActionsWidget } from '../components/ActionsWidget'

interface ImportDialogProps {
  className?: string
  visible: boolean
  onClose: () => void
  onConfirm: (scheme?: string) => void
  formSchema: string
}

const ImportDialog: React.FC<ImportDialogProps> = ({
  className,
  visible,
  formSchema,
  onConfirm,
  onClose
}) => {
  return visible ? (
    <Drawer
      value={visible}
      width={'100%'}
      title="配置执行表单"
      container={() => document.getElementById('scene_detail')}
      onChangeValue={show => {
        if (!show) {
          onClose()
        }
      }}
    >
      <div className={className}>
        <FormDesignable
          actions={
            <ActionsWidget
              onConfirm={(value: string) => {
                onConfirm(value)
              }}
              onCancel={() => onClose()}
              schema={formSchema || ''}
            />
          }
        />
      </div>
    </Drawer>
  ) : null
}

export default styled(ImportDialog)``
